import getComponentName from '../utils/schema/getComponentName';
import validateSchema from '../utils/schema/validate/validateSchema';
import contexts from './contexts';
import {isPlainObject} from '@servicenow/ui-utils';

export default function validateContext(context, host) {
	if (isPlainObject(context)) {
		const contextKeys = Reflect.ownKeys(context);
		for (let i = 0; i < contextKeys.length; i++) {
			const k = contextKeys[i];
			if (contexts.has(k)) {
				const {validate} = contexts.get(k);
				validateSchema(validate, context[k], {
					errorPrefix: `Context property for ${getComponentName(host)}: `
				});
			}
		}
	}
}
